export const AVAILABLE_ASSET_IN_BALANCE_LOCKED_LS_KEY =
  'availableAssetInBalanceLocked';
export const BLOCKED_VOTE_BUTTON_LS_KEY = 'blockedVoteButton';
export const CUSTOM_SLIPPAGE_LS_KEY = 'customSlippage';
export const DONT_SHOW_ON_STARTUP_LS_KEY = 'dontShowOnStartup';
export const IS_FEE_DISCOUNT_NOTIFICATION_HIDDEN_LS_KEY =
  'isFeeDiscountNotificationHidden';
export const IS_FIRST_LAUNCH_LS_KEY = 'isFirstLaunch';
export const IS_GOVERNANCE_NOTIFICATION_HIDDEN_LS_KEY =
  'isGovernanceNotificationHidden';
export const IS_HEADER_HIDDEN_LS_KEY = 'isHeaderHidden';
export const LAST_SWAP_ASSETS_LS_KEY = 'lastSwapAssets';
export const MOBILE_APP_CHAIN_ID_LS_KEY = 'mobileAppChainId';
export const MOBILE_WALLET_ADDRESS_LS_KEY = 'mobileWalletAddress';
export const PAIR_SELECTOR_TAB_LS_KEY = 'pairSelectorTab';
export const PRIVATE_KEY_LS_KEY = 'privateKey';
export const RAW_EXCHANGE_RESTRICTIONS_LS_KEY = 'rawExchangeRestrictions';
export const RAW_EXCHANGE_RESTRICTIONS_ENABLED_LS_KEY =
  'rawExchangeRestrictionsEnabled';
export const REVERSED_SWAP_IDS_LS_KEY = 'reversedSwapIds';
export const SIDEBAR_STATE_LS_KEY = 'sidebarState';
export const SLIPPAGE_IS_CUSTOM_LS_KEY = 'slippageIsCustom';
